// PWA-style pastel avatar palette (soft bg + darker initial) — shared so the
// desktop web chat list matches the mobile PWA look.
export const AVATAR_PALETTE = [
  { bg: '#DCE7F5', fg: '#2E5AAC' }, // soft blue
  { bg: '#D6EDDA', fg: '#1F6E3A' }, // soft green
  { bg: '#F7DED0', fg: '#B14A16' }, // soft peach
  { bg: '#EBD9F0', fg: '#6B2E82' }, // soft purple
  { bg: '#FBE1E1', fg: '#B32828' }, // soft rose
  { bg: '#D9EEF2', fg: '#1F6B7C' }, // soft teal
  { bg: '#F4E6C7', fg: '#8B6914' }, // soft mustard
  { bg: '#E5E1F5', fg: '#3B3591' }, // soft indigo
];

export const avatarPalFor = (name) =>
  AVATAR_PALETTE[((name || '?').charCodeAt(0) || 0) % AVATAR_PALETTE.length];
